
export const StorageService = {
  getPendingPayment: (): string | null => {
    return localStorage.getItem("LP-pending-payment");
  },
  setPendingPayment: (value: string) => {
    localStorage.setItem("LP-pending-payment", value)
  },
  removePendingPayment: () => {
    localStorage.removeItem("LP-pending-payment");
  }
}
